"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
const Theme = (0, _styles.createTheme)({
  breakpoints: {
    values: {
      xs: 0,
      sm: 440,
      md: 768,
      lg: 1024,
      xl: 1440,
      mobile: 0,
      tablet: 800,
      laptop: 1040,
      desktop: 1440
    }
  },
  spacing: factor => {
    const values = [0, 5, 10, 20, 30, 60, 90, 110, 150, 200, 250];
    return values[factor];
  },
  shadows: ['none', '0px 2px 1px -1px rgba(6,21,86,0.2),0px 1px 1px 0px rgba(6,21,86,0.14),0px 1px 3px 0px rgba(6,21,86,0.12)', '0px 3px 1px -2px rgba(6,21,86,0.2),0px 2px 2px 0px rgba(6,21,86,0.14),0px 1px 5px 0px rgba(6,21,86,0.12)', '0px 3px 3px -2px rgba(6,21,86,0.2),0px 3px 4px 0px rgba(6,21,86,0.14),0px 1px 8px 0px rgba(6,21,86,0.12)', '0px 2px 4px -1px rgba(6,21,86,0.2),0px 4px 5px 0px rgba(6,21,86,0.14),0px 1px 10px 0px rgba(6,21,86,0.12)', '0px 3px 5px -1px rgba(6,21,86,0.2),0px 5px 8px 0px rgba(6,21,86,0.14),0px 1px 14px 0px rgba(6,21,86,0.12)', '0px 3px 5px -1px rgba(6,21,86,0.2),0px 6px 10px 0px rgba(6,21,86,0.14),0px 1px 18px 0px rgba(6,21,86,0.12)', '0px 4px 5px -2px rgba(6,21,86,0.2),0px 7px 10px 1px rgba(6,21,86,0.14),0px 2px 16px 1px rgba(6,21,86,0.12)', '0px 5px 5px -3px rgba(6,21,86,0.2),0px 8px 10px 1px rgba(6,21,86,0.14),0px 3px 14px 2px rgba(6,21,86,0.12)', '0px 5px 6px -3px rgba(6,21,86,0.2),0px 9px 12px 1px rgba(6,21,86,0.14),0px 3px 16px 2px rgba(6,21,86,0.12)', '0px 6px 6px -3px rgba(6,21,86,0.2),0px 10px 14px 1px rgba(6,21,86,0.14),0px 4px 18px 3px rgba(6,21,86,0.12)', '0px 6px 7px -4px rgba(6,21,86,0.2),0px 11px 15px 1px rgba(6,21,86,0.14),0px 4px 20px 3px rgba(6,21,86,0.12)', '0px 7px 8px -4px rgba(6,21,86,0.2),0px 12px 17px 2px rgba(6,21,86,0.14),0px 5px 22px 4px rgba(6,21,86,0.12)', '0px 7px 8px -4px rgba(6,21,86,0.2),0px 13px 19px 2px rgba(6,21,86,0.14),0px 5px 24px 4px rgba(6,21,86,0.12)', '0px 7px 9px -4px rgba(6,21,86,0.2),0px 14px 21px 2px rgba(6,21,86,0.14),0px 5px 26px 4px rgba(6,21,86,0.12)', '0px 8px 9px -5px rgba(6,21,86,0.2),0px 15px 22px 2px rgba(6,21,86,0.14),0px 6px 28px 5px rgba(6,21,86,0.12)', '0px 8px 10px -5px rgba(6,21,86,0.2),0px 16px 24px 2px rgba(6,21,86,0.14),0px 6px 30px 5px rgba(6,21,86,0.12)', '0px 8px 11px -5px rgba(6,21,86,0.2),0px 17px 26px 2px rgba(6,21,86,0.14),0px 6px 32px 5px rgba(6,21,86,0.12)', '0px 9px 11px -5px rgba(6,21,86,0.2),0px 18px 28px 2px rgba(6,21,86,0.14),0px 7px 34px 6px rgba(6,21,86,0.12)', '0px 9px 12px -6px rgba(6,21,86,0.2),0px 19px 29px 2px rgba(6,21,86,0.14),0px 7px 36px 6px rgba(6,21,86,0.12)', '0px 10px 13px -6px rgba(6,21,86,0.2),0px 20px 31px 3px rgba(6,21,86,0.14),0px 8px 38px 7px rgba(6,21,86,0.12)', '0px 10px 13px -6px rgba(6,21,86,0.2),0px 21px 33px 3px rgba(6,21,86,0.14),0px 8px 40px 7px rgba(6,21,86,0.12)', '0px 10px 14px -6px rgba(6,21,86,0.2),0px 22px 35px 3px rgba(6,21,86,0.14),0px 8px 42px 7px rgba(6,21,86,0.12)', '0px 11px 14px -7px rgba(6,21,86,0.2),0px 23px 36px 3px rgba(6,21,86,0.14),0px 9px 44px 8px rgba(6,21,86,0.12)', '0px 11px 15px -7px rgba(6,21,86,0.2),0px 24px 38px 3px rgba(6,21,86,0.14),0px 9px 46px 8px rgba(6,21,86,0.12)'],
  typography: {
    proxima: {
      regular: 'Proxima, Roboto, Arial, sans-serif',
      bold: 'ProximaBold',
      light: 'ProximaLight',
      semiBold: 'ProximaSemiBold'
    },
    Kapra: {
      regular: 'Kapra'
    }
  },
  palette: {
    primary: {
      light: '#005EDC',
      main: '#061556',
      neutral: '#0022BD',
      headerShadow: '#06155666'
    },
    secondary: {
      main: '#FEBD11'
    },
    error: {
      main: '#ED1D24',
      warning: '#FF6B00'
    },
    grayScale: {
      dark: '#4A4A4A',
      main: '#787A7E',
      light: '#F5F5F5',
      disabled: '#7B7B7B',
      middleLight: '#BBBBBB',
      lowMiddleLight: '#535353',
      placeholder: '#9F9F9F'
    },
    border: '#CCCED8',
    divider: '#E5E5E5',
    shadow: '#06155626',
    background: '#E8E9EB',
    darkBackground: '#CDCFD1',
    white: '#FFFFFF',
    green: '#05A56B'
  },
  overrides: {
    MuiDivider: {
      root: {
        backgroundColor: '#CCCED8'
      }
    },
    MuiPaper: {
      root: {
        backgroundColor: '#FFFFFF'
      }
    },
    MuiTableCell: {
      body: {
        fontSize: '16px',
        color: '#4A4A4A'
      }
    },
    MuiTypography: {
      body1: {
        letterSpacing: 0
      },
      body2: {
        letterSpacing: 0
      },
      caption: {
        letterSpacing: 0,
        fontSize: '12px',
        color: '#4A4A4A'
      }
    }
  }
});
var _default = exports.default = Theme;